import flat from './flat.ejs'
import form from './form.ejs'

export default { flat, form }
